import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { FormService } from 'src/app/core/services/form/form.service';
import { NotificationService } from 'src/app/core/services/notification/notification.service';

@Component({
  selector: 'visitor-mobile-navbar',
  templateUrl: './mobile-navbar.component.html',
  styleUrls: ['./mobile-navbar.component.css']
})
export class MobileNavbarComponent implements OnInit {

  @ViewChild('sideBarRight') sideBarRight: ElementRef;
  @ViewChild('sideBarLeft') sideBarLeft: ElementRef;
  @ViewChild('wrapper') wrapper: ElementRef;

  @Input()
  OpenLeftInput: any;
  public collapseServices: boolean;
  public collapseProjects: boolean;
  public form: FormGroup;
  public openLeft: number = 1;
  public openRight: number = 1;

  constructor(private notificationService: NotificationService, private formService: FormService) {
    this.buildForm();
    this.collapseServices = false;
    this.collapseProjects = false;
  }

  ngOnInit(): void {
    
  }
  ngOnChanges(){
    if( this.OpenLeftInput){
      this.openSideBarLeft();
    }
  }

  public buildForm(): void {
    this.form = this.formService.buildFormGroup({
      name: [ '', [ Validators.required ] ],
      email: ['', [ Validators.required, Validators.email ] ],
      message: ['', [ Validators.required ]]
    });
  }

  public openSideBarRight(): void {
    this.sideBarRight.nativeElement.style.width = '270px';
    this.closeSideBarLeft();
  } 

  public closeSideBarRight(): void {
    this.sideBarRight.nativeElement.style.width = '0';
  }

  public openSideBarLeft(): void {
    this.sideBarLeft.nativeElement.style.width = '270px';
    this.closeSideBarRight();
  }

  public closeSideBarLeft(): void {
    this.sideBarLeft.nativeElement.style.width = '0'
  }

  public setServicesCollapse(): void {
    this.collapseServices = !this.collapseServices;
  }

  public setProjectCollapse(): void {
    this.collapseProjects = !this.collapseProjects;
  }

  public controlIsRequired(formControlName: string): boolean {
    return this.formService.controlIsRequired(this.form, formControlName);
  }

  public controlIsInvalid(formControlName: string): boolean {
    return this.formService.controlIsInvalid(this.form, formControlName);
  }

  public controlIsInvalidEmail(formControlName: string): boolean {
    return this.formService.controlIsInvalidEmail(this.form, formControlName);
  }

  public controlIsInvalidPattern(formControlName: string): boolean {
    return this.formService.controlIsInvalidPattern(this.form, formControlName);
  }

  public controlIsInvalidLength(formControlName: string): boolean {
    return this.formService.controlIsInvalidLength(this.form, formControlName);
  }

  public send(form: FormGroupDirective): void {
    if (this.form.valid) {
      this.notificationService.success('Mensaje enviado');
      this.form.reset();
      form.resetForm();
    }
  }

}
